/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';

import {
  Box,
  Card,
  CardContent,
  Collapse,
  Divider,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from '@material-ui/core';
import {
  AccessTime,
  Assignment,
  Business,
  Email,
  ExpandLess,
  ExpandMore,
  Person,
  Phone,
  Schedule,
  Smartphone,
  Update,
} from '@material-ui/icons';

import { useBudget } from '../../context/BudgetContext';
import { useStyles } from './styles';

export default function ClienteInfo() {
  const classes = useStyles();
  const theme = useTheme();

  const {
    budget: { client, model, product, createdAt, updatedAt },
  } = useBudget();

  const [expanded, setExpanded] = useState(() => {
    const saved = localStorage.getItem('budgetClientInfoExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem('budgetClientInfoExpanded', JSON.stringify(expanded));
  }, [expanded]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const calculateTAT = () => {
    if (!createdAt) return null;

    const created = new Date(createdAt || updatedAt);
    const now = new Date();
    const diffMs = now - created;

    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    if (days > 0) {
      return `${days}d ${hours}h`;
    } else if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${minutes}m`;
    }
  };

  const tat = calculateTAT();

  const InfoRow = ({ icon: Icon, label, value }) => (
    <Box display='flex' alignItems='center' mb={1.5}>
      <Icon style={{ color: theme.palette.primary.main, marginRight: 12, fontSize: 20 }} />
      <Box>
        <Typography variant='caption' color='textSecondary' display='block'>
          {label}
        </Typography>
        <Typography variant='body2' style={{ fontWeight: 500 }}>
          {value || '-'}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box
          className={classes.header}
          style={{ cursor: 'pointer' }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box display='flex' alignItems='center'>
            <Person className={classes.icon} />
            <Typography variant='h6' className={classes.title}>
              Dados do Cliente
            </Typography>
          </Box>
          <IconButton size='small'>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>

        <Collapse in={expanded}>
          <Grid container spacing={3} style={{ marginTop: 8 }}>
            <Grid item xs={12} sm={6}>
              <InfoRow icon={Person} label='Nome' value={client.name} />
              <InfoRow icon={Business} label='CPF/CNPJ' value={client.cgc} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InfoRow icon={Phone} label='Telefone' value={client.phoneNumber} />
              <InfoRow icon={Email} label='E-mail' value={client.email} />
            </Grid>

            <Grid item xs={12}>
              <Divider style={{ margin: '8px 0' }} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InfoRow icon={Smartphone} label='Modelo' value={model} />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InfoRow icon={Assignment} label='Produto' value={product} />
            </Grid>

            <Grid item xs={12}>
              <Divider style={{ margin: '8px 0' }} />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InfoRow icon={Schedule} label='Data de Criação' value={formatDate(createdAt)} />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InfoRow icon={Update} label='Última Atualização' value={formatDate(updatedAt)} />
            </Grid>

            {tat && (
              <Grid item xs={12} sm={4}>
                <Box display='flex' alignItems='center' mb={1.5}>
                  <AccessTime
                    style={{ color: theme.palette.primary.main, marginRight: 12, fontSize: 20 }}
                  />
                  <Box>
                    <Typography variant='caption' color='textSecondary' display='block'>
                      TAT
                    </Typography>
                    <Typography
                      variant='body2'
                      style={{
                        fontWeight: 600,
                        color: '#2196f3',
                      }}
                    >
                      {tat}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {client.laudo && (
              <>
                <Grid item xs={12}>
                  <Divider style={{ margin: '8px 0' }} />
                </Grid>
                <Grid item xs={12}>
                  <Box display='flex' alignItems='flex-start'>
                    <Assignment
                      style={{ color: theme.palette.primary.main, marginRight: 12, fontSize: 20 }}
                    />
                    <Box flex={1}>
                      <Typography variant='caption' color='textSecondary' display='block'>
                        Laudo Técnico
                      </Typography>
                      <Typography variant='body2' style={{ fontWeight: 400, marginTop: 4 }}>
                        {client.laudo}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
        </Collapse>
      </CardContent>
    </Card>
  );
}
